(function() {
  var UPLOADCARE_PUBLIC_KEY = '87a718ad71e8f7a21b21';
  var KLAVIYO_PUBLIC_KEY = 'pk_7b64485d829fdde343b63822049f0f12b5';
  var PROOF_BOX_VARIANT_ID = 50762810720542;

  var state = {
    designUrl: null,
    uploadedFilename: null,
    uploadedFileSize: null,
    uploadedFileType: null,
    uploadZoneState: 'idle'
  };

  function setUploadZoneState(s) {
    state.uploadZoneState = s;
    var zone = document.getElementById('pb-upload-zone');
    if (zone) zone.setAttribute('data-state', s);
  }

  function showUploadError(msg) {
    var el = document.getElementById('pb-upload-error');
    if (el) el.textContent = msg;
    setUploadZoneState('error');
  }

  function clearUploadError() {
    var el = document.getElementById('pb-upload-error');
    if (el) el.textContent = '';
  }

  function setProgress(pct) {
    var progress = document.getElementById('pb-upload-progress');
    var bar = progress ? progress.querySelector('.pb-upload__progress-bar') : null;
    if (bar) bar.style.width = pct + '%';
    if (progress) progress.setAttribute('aria-valuenow', String(pct));
  }

  function validateFile(file) {
    var allowed = ['image/png', 'image/jpeg', 'application/pdf'];
    if (!file) {
      return 'Upload a PNG, JPG, or PDF before starting your Proof Box.';
    }
    if (allowed.indexOf(file.type) === -1) {
      return 'Only PNG, JPG, or PDF files are accepted right now.';
    }
    if (file.size > 1000 * 1024 * 1024) {
      return 'File must be under 1000MB.';
    }
    return null;
  }

  function trackKlaviyo(event, props) {
    if (typeof window._learnq === 'undefined') return;
    window._learnq.push(['track', event, props]);
  }

  function onUploadSuccess(cdnUrl, file) {
    state.designUrl = cdnUrl;
    setProgress(100);
    setUploadZoneState('success');

    var zone = document.getElementById('pb-upload-zone');
    if (zone) zone.classList.add('pb-upload-zone--collapsed');

    var mockupSection = document.getElementById('pb-mockup-section');
    if (mockupSection) {
      mockupSection.classList.add('pb-mockup--visible');
      mockupSection.setAttribute('aria-hidden', 'false');
    }

    document.body.classList.add('pb-page--mockup-revealed');

    document.dispatchEvent(new CustomEvent('proofbox:upload-complete', {
      detail: { designUrl: cdnUrl, filename: state.uploadedFilename }
    }));

    trackKlaviyo('Proof Box Upload Complete', {
      designUrl: cdnUrl,
      filename: state.uploadedFilename
    });
  }

  function uploadViaUploadcare(file) {
    setUploadZoneState('uploading');
    clearUploadError();
    setProgress(0);

    trackKlaviyo('Proof Box Upload Started', {
      filename: file.name,
      fileSize: file.size,
      fileType: file.type
    });

    if (!window.uploadcare || !UPLOADCARE_PUBLIC_KEY) {
      var reader = new FileReader();
      reader.onprogress = function(e) {
        if (e.lengthComputable) {
          setProgress(Math.round((e.loaded / e.total) * 90));
        }
      };
      reader.onload = function(e) {
        setProgress(100);
        onUploadSuccess(e.target.result, file);
      };
      reader.onerror = function() {
        showUploadError('Failed to read file. Please try again.');
      };
      reader.readAsDataURL(file);
      return;
    }

    uploadcare.start({ publicKey: UPLOADCARE_PUBLIC_KEY });

    var fileObj = uploadcare.fileFrom('object', file);

    fileObj.progress(function(info) {
      var pct = Math.round(info.progress * 100);
      setProgress(pct);
    });

    fileObj.done(function(info) {
      onUploadSuccess(info.cdnUrl, file);
    });

    fileObj.fail(function(error) {
      showUploadError('Upload failed: ' + (error || 'unknown error') + '. Please try again.');
    });
  }

  function handleFileSelected(file) {
    if (!file) return;
    state.uploadedFilename = file.name;
    state.uploadedFileSize = file.size;
    state.uploadedFileType = file.type;

    var err = validateFile(file);
    if (err) {
      showUploadError(err);
      return;
    }

    uploadViaUploadcare(file);
  }

  function initUploadZone() {
    var zone = document.getElementById('pb-upload-zone');
    var input = document.getElementById('pb-upload-input');
    if (!zone || !input) return;

    setUploadZoneState('idle');

    zone.addEventListener('click', function() {
      if (state.uploadZoneState === 'uploading' || state.uploadZoneState === 'success') return;
      input.click();
    });

    zone.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (state.uploadZoneState === 'uploading' || state.uploadZoneState === 'success') return;
        input.click();
      }
    });

    input.addEventListener('change', function(e) {
      handleFileSelected(e.target.files[0]);
    });

    zone.addEventListener('dragover', function(e) {
      e.preventDefault();
      if (state.uploadZoneState === 'uploading' || state.uploadZoneState === 'success') return;
      setUploadZoneState('drag-over');
    });

    zone.addEventListener('dragleave', function() {
      if (state.uploadZoneState === 'drag-over') {
        setUploadZoneState('idle');
      }
    });

    zone.addEventListener('drop', function(e) {
      e.preventDefault();
      if (state.uploadZoneState === 'uploading' || state.uploadZoneState === 'success') return;
      var file = e.dataTransfer.files[0];
      handleFileSelected(file);
    });
  }

  function initGarmentChangedListener() {
    document.addEventListener('proofbox:garment-changed', function(e) {
      var garmentSelect = document.getElementById('pb-garment-type');
      if (!garmentSelect || !e.detail || !e.detail.type) return;
      var valueMap = {
        'cotton-tshirt': 'tshirt',
        'polyester-blend-tshirt': 'tshirt',
        'cotton-hoodie': 'hoodie',
        'cotton-tote': 'tote'
      };
      var targetValue = valueMap[e.detail.type] || e.detail.type;
      var options = garmentSelect.options;
      for (var i = 0; i < options.length; i++) {
        if (options[i].value === targetValue) {
          garmentSelect.selectedIndex = i;
          break;
        }
      }
    });
  }

  function setFieldError(field, hasError) {
    if (!field) return;
    var wrapper = field.closest('.pb-field');
    if (!wrapper) return;
    if (hasError) {
      wrapper.classList.add('pb-field--error');
    } else {
      wrapper.classList.remove('pb-field--error');
    }
  }

  function validateEmail(val) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
  }

  function validateForm(form) {
    var valid = true;

    var emailField = form.querySelector('[name="email"]');
    var nameField = form.querySelector('[name="full_name"]');
    var garmentField = form.querySelector('[name="garment_type"]');

    var emailVal = emailField ? emailField.value.trim() : '';
    var nameVal = nameField ? nameField.value.trim() : '';
    var garmentVal = garmentField ? garmentField.value.trim() : '';
    var uploadErr = !state.designUrl;

    var emailErr = !emailVal || !validateEmail(emailVal);
    var nameErr = !nameVal;
    var garmentErr = !garmentVal;

    setFieldError(emailField, emailErr);
    setFieldError(nameField, nameErr);
    setFieldError(garmentField, garmentErr);

    if (uploadErr) showUploadError('Upload your file before starting the Proof Box.');
    if (emailErr || nameErr || garmentErr || uploadErr) valid = false;

    return valid;
  }

  function setSubmitLoading(isLoading) {
    var btn = document.getElementById('pb-submit-btn');
    var spinner = document.getElementById('pb-submit-spinner');
    var btnText = document.getElementById('pb-submit-btn-text');
    if (!btn) return;
    if (isLoading) {
      btn.classList.add('pb-btn--loading');
      btn.setAttribute('disabled', 'disabled');
      if (spinner) spinner.style.display = '';
      if (btnText) btnText.style.opacity = '0';
    } else {
      btn.classList.remove('pb-btn--loading');
      btn.removeAttribute('disabled');
      if (spinner) spinner.style.display = 'none';
      if (btnText) btnText.style.opacity = '';
    }
  }

  function showFormError(msg) {
    var el = document.getElementById('pb-form-error');
    if (!el) return;
    el.textContent = msg;
    el.style.display = 'block';
  }

  function clearFormError() {
    var el = document.getElementById('pb-form-error');
    if (!el) return;
    el.textContent = '';
    el.style.display = 'none';
  }

  function addToCart(formData) {
    var garmentType = formData.garment_type || '';
    var businessName = formData.business_name || '';
    var email = formData.email || '';
    var fullName = formData.full_name || '';

    var payload = {
      items: [{
        id: PROOF_BOX_VARIANT_ID,
        quantity: 1,
        properties: {
          '_design_url': state.designUrl || '',
          'Full Name': fullName,
          'Email': email,
          'Garment Preference': garmentType,
          'Business Name': businessName
        }
      }]
    };

    trackKlaviyo('Proof Box Added to Cart', {
      designUrl: state.designUrl,
      fullName: fullName,
      garmentPreference: garmentType,
      businessName: businessName,
      email: email,
      price: 4.99
    });

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
  }

  function initOrderForm() {
    var form = document.getElementById('pb-order-form');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      clearFormError();

      if (!validateForm(form)) {
        showFormError('Please upload your file and complete the required fields.');
        return;
      }

      var formData = {
        email: (form.querySelector('[name="email"]') || {}).value || '',
        full_name: (form.querySelector('[name="full_name"]') || {}).value || '',
        business_name: (form.querySelector('[name="business_name"]') || {}).value || '',
        garment_type: (form.querySelector('[name="garment_type"]') || {}).value || ''
      };

      setSubmitLoading(true);

      addToCart(formData).then(function(res) {
        if (!res.ok) {
          return res.json().then(function(data) {
            throw new Error(data.description || data.message || 'Failed to add to cart.');
          });
        }
        window.location.href = '/checkout';
      }).catch(function(err) {
        setSubmitLoading(false);
        showFormError(err.message || 'Something went wrong. Please try again.');
      });
    });
  }

  function initFloatingCta() {
    var cta = document.getElementById('pb-floating-cta');
    var form = document.getElementById('pb-order-form');
    if (!cta || !form) return;

    var formVisible = false;

    function syncFloatingCta() {
      var scrolledEnough = window.scrollY > Math.max(420, window.innerHeight * 0.7);
      if (scrolledEnough && !formVisible) {
        cta.classList.add('pb-floating-cta--visible');
      } else {
        cta.classList.remove('pb-floating-cta--visible');
      }
    }

    cta.addEventListener('click', function() {
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    var observer = new IntersectionObserver(function(entries) {
      var entry = entries[0];
      formVisible = entry.isIntersecting;
      syncFloatingCta();
    }, { threshold: 0.1 });

    observer.observe(form);
    window.addEventListener('scroll', syncFloatingCta, { passive: true });
    window.addEventListener('resize', syncFloatingCta);
    syncFloatingCta();
  }

  function initScrollAnimations() {
    var elements = document.querySelectorAll('.pb-animate-in');
    if (!elements.length) return;

    if (!window.IntersectionObserver) {
      for (var i = 0; i < elements.length; i++) {
        elements[i].classList.add('pb-animate-in--visible');
      }
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          entries[i].target.classList.add('pb-animate-in--visible');
          observer.unobserve(entries[i].target);
        }
      }
    }, { threshold: 0.15 });

    for (var j = 0; j < elements.length; j++) {
      observer.observe(elements[j]);
    }
  }

  function initCinematicEntrance() {
    var hero = document.getElementById('pb-hero');
    if (!hero) return;
    document.documentElement.classList.remove('pb-intro-active');
    hero.classList.add('pb-hero--active');
  }

  function initKlaviyoPageView() {
    trackKlaviyo('Proof Box Page Viewed', {
      url: window.location.href,
      referrer: document.referrer
    });
  }

  function init() {
    document.body.classList.add('pb-page');
    initKlaviyoPageView();
    initUploadZone();
    initGarmentChangedListener();
    initOrderForm();
    initFloatingCta();
    initScrollAnimations();
    initCinematicEntrance();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
